import Loading from '../../../Common/Loading';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';
import { Gender } from './Gender';
import { MaritalStatus } from './MaritalStatus';
import { AgeGroup } from './AgeGroup';
import { Scholarity } from './Scholarity';
import { StudySeries } from './StudySeries';

export const Charts = () => {
    const { isLoading } = useIdentificationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <Gender />
                <MaritalStatus />
                <AgeGroup />
            </div>
            <div className="charts-side-by-side-dashboards">
                <Scholarity />
                <StudySeries />
            </div>
        </>
    );
};
